module.exports = __webpack_public_path__ + "static/media/Street Graffiti.c1427ca1.jpg";